import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
// axios.defaults.headers['Platform'] = 'web'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 创建axios实例
window.BASE_URL = process.env.NODE_ENV === 'production' ? process.env.BASE_API : process.env.BASE_API
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL : 'http://47.92.215.85/',
  // 超时
  timeout: 10 * 2000,
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 让每个请求携带自定义token 请根据实际情况自行修改
    const token = window.localStorage.getItem('token')
    config.headers['Authorization'] = token
    return config;
  },
  error => {
    console.log('err：' + error);
    return Promise.reject(error);
  }
)

let messageBoxFlag = 0 // 默认 MessageBox 未打开
// 响应拦截器
service.interceptors.response.use(
  response => {
     // return response;
    // 未设置状态码则默认成功状态
    const code = response.data.code || 2000;
    // 获取错误信息
    const errorCode = {
        '401': '认证失败，无法访问系统资源',
        '403': '当前操作没有权限',
        '404': '访问资源不存在',
        'default': '系统未知错误,请反馈给管理员'
    };
    const msg = errorCode[code] || response.data.msg || errorCode['default'];
    if (code === 500) {
      return Promise.reject(new Error(msg))
    }else if(code === 403){
      if (messageBoxFlag === 0) {
        messageBoxFlag = 1
        MessageBox.confirm('系统检测到您的账号长时间未操作或账号在其他设备登录, 是否重新登录?', '警告', {
          confirmButtonText: '去登录',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          messageBoxFlag = 0  // 修改标记
          window.location = window.location.origin
        }).catch(() => {
          messageBoxFlag = 0  // 修改标记
        })
      }
      window.localStorage.clear()
      return response.data
    }else if(code === 406) {
      if (messageBoxFlag === 0) {
        messageBoxFlag = 1
        MessageBox.confirm('尊敬的客户：您好，由于您的登录IP已达到上限，建议您在常用设备登录。如有疑问，请跳转个人中心。感谢您的关注！', '温馨提示', {
          confirmButtonText: '个人中心',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          messageBoxFlag = 0  // 修改标记
          window.location = '#/UCenter'
        }).catch(() => {
          messageBoxFlag = 0  // 修改标记
        })
      }
    }else{
        return response.data
    }
  },
  error => {
    console.log('err：' + error);
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    return Promise.reject(message);
  }
)
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js